export enum UserRoles {
  SuperAdmin = 1,
  Admin = 2,
  User = 3,
  Member = 4,
  Vendor = 5,
  Reseller = 6
}
